<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-briefcase"></i>
                    <span>{{$t('dashboard.work_experience.title')}}</span>
                </h2>
                <div @click.prevent="addNew" class="panel_header__action">
                    <i class="panel_header__action__icon icons icon-plus"></i>
                    <a class="button--link hidden-xs">{{$t('dashboard.work_experience.add_new')}}</a>
                </div>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="loading">
                    <div class="spinner"></div>
                </div>
                <div v-else-if="!workExperienceItems.length" class="panel--empty">
                    <center>{{$t('dashboard.work_experience.no_experience')}}</center>
                </div>
                <div v-else class="panel__list">
                    <work-experience-item v-for="item in workExperienceItems" :key="item.id" :item="item" />
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.work_experience.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.work_experience.see_all')}}</div>
            </div>
        </div>
        <work-experience-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import WorkExperienceItem from './WorkExperienceItem';
    import WorkExperienceModal from '@/components/modals/dashboard/WorkExperienceModal';

    import { GET_WORK_EXPERIENCE } from '@/store/modules/work-experience';

    import WorkExperience from '@/models/WorkExperience';

    @Component({
        components: {
            WorkExperienceItem,
            WorkExperienceModal,

        }
    })
    export default class WorkExperiencePanel extends Vue {
        name = 'work-experience-panel';
        expanded = false;

        created() {
            this.$store.dispatch(GET_WORK_EXPERIENCE, {});
        }

        get loading() {
            return this.$store.state.work_experience.loading;
        }

        get workExperienceItems() {
            return this.$store.state.work_experience.work_experience;
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.workExperienceItems.length && this.workExperienceItems.length > 2;
        }

        addNew() {
            const url = `/clients/${this.$store.state.trajectory.trajectory.client.id}/experience`;
            const experience = new (WorkExperience.makeModel(url));
            this.$modal.show('work-experience-modal', { experience });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/WorkExperiencePanel.vue